export enum SecurityType {
  FUND = 'FUND',
  MONEY_MARKET_FUND = 'MONEY_MARKET_FUND',
  COMMON_STOCK = 'COMMON_STOCK',
  PREFERRED_STOCK = 'PREFERRED_STOCK',
  CONVERTIBLE_PREFERRED_STOCK = 'CONVERTIBLE_PREFERRED_STOCK',
  PREFERRED_STOCK_CONVERTIBLE = 'PREFERRED_STOCK_CONVERTIBLE',
  PREFERRED_STOCK_AMERICAN_DEPOSITORY_RECE = 'PREFERRED_STOCK_AMERICAN_DEPOSITORY_RECE',
  RIGHTS = 'RIGHTS',
  WARRANT = 'WARRANT',
  UNITS = 'UNITS',
  MUTUAL_FUND = 'MUTUAL_FUND',
  LIMITED_PARTNERSHIP = 'LIMITED_PARTNERSHIP',
  CALL_OPTION = 'CALL_OPTION',
  PUT_OPTION = 'PUT_OPTION',
  BANK_CALL_OPTION = 'BANK_CALL_OPTION',
  ESCROW = 'ESCROW',
  CORPORATE_BOND = 'CORPORATE_BOND',
  CONVERTIBLE_BOND = 'CONVERTIBLE_BOND',
  CORPORATE_BOND_NOTE = 'CORPORATE_BOND_NOTE',
  CORPORATE_BOND_NOTE_CONVERTIBLE = 'CORPORATE_BOND_NOTE_CONVERTIBLE',
  CORPORATE_BOND_NON_CONVERTIBLE_DOMESTIC = 'CORPORATE_BOND_NON_CONVERTIBLE_DOMESTIC',
  CORPORATE_BOND_NOTE_CONVERTIBLE_DOMESTIC = 'CORPORATE_BOND_NOTE_CONVERTIBLE_DOMESTIC',
  CORPORATE_NOTE_NON_CONVERTIBLE_DOMESTIC = 'CORPORATE_NOTE_NON_CONVERTIBLE_DOMESTIC',
  CORPORATE_UNITS_BONDS = 'CORPORATE_UNITS_BONDS',
  MUNICIPAL_BOND = 'MUNICIPAL_BOND',
  MUNI_DOUBLE_BARRELED_BOND = 'MUNI_DOUBLE_BARRELED_BOND',
  MUNI_GENERAL_OBLIGATION = 'MUNI_GENERAL_OBLIGATION',
  MUNI_REVENUE_BOND = 'MUNI_REVENUE_BOND',
  MUNICIPAL_BOND_NOTE = 'MUNICIPAL_BOND_NOTE',
  MUNICIPAL_LEASES = 'MUNICIPAL_LEASES',
  MUNICIPAL_BOND_SERIAL = 'MUNICIPAL_BOND_SERIAL',
  MUNICIPAL_NOTE_SHORT_TERM = 'MUNICIPAL_NOTE_SHORT_TERM',
  SHORT_TERM_PAPER = 'SHORT_TERM_PAPER',
  BOND_UNIT = 'BOND_UNIT',
  MUNI_ASSESSMENT_DIST = 'MUNI_ASSESSMENT_DIST',
  US_TREASURY_BILL = 'US_TREASURY_BILL',
  US_TREASURY_NOTE = 'US_TREASURY_NOTE',
  US_TREASURY_BOND = 'US_TREASURY_BOND',
  OTHER_GOVERNMENT = 'OTHER_GOVERNMENT',
  US_TREASURY_ZERO_COUPON = 'US_TREASURY_ZERO_COUPON',
  TREASURY_BILL = 'TREASURY_BILL',
  TREASURY_BOND = 'TREASURY_BOND',
  TREASURY_INFLATION_INDEXED = 'TREASURY_INFLATION_INDEXED',
  TREASURY_NOTE = 'TREASURY_NOTE',
  TREASURY_STRIPS = 'TREASURY_STRIPS',
  US_TREASURY_FUTURE_BILL = 'US_TREASURY_FUTURE_BILL',
  US_TREASURY_REGULAR_BOND_NOTE = 'US_TREASURY_REGULAR_BOND_NOTE',
  GOVERNMENT_BOND = 'GOVERNMENT_BOND',
  GOVERNMENT_MORTGAGE = 'GOVERNMENT_MORTGAGE',
  COLLATERALIZED_MORTGAGE_OBLIGATION = 'COLLATERALIZED_MORTGAGE_OBLIGATION',
  FEDERAL_AGENCY_BOND = 'FEDERAL_AGENCY_BOND',
  FEDERAL_AGENCY_PASS_THROUGH = 'FEDERAL_AGENCY_PASS_THROUGH',
  FEDERAL_AGENCY_REGULAR_BILL = 'FEDERAL_AGENCY_REGULAR_BILL',
  TAX_SHELTER = 'TAX_SHELTER',
  WHEN_AS_AND_IF_ISSUED_EQUITY = 'WHEN_AS_AND_IF_ISSUED_EQUITY',
  WHEN_AS_AND_IF_ISSUED_BOND = 'WHEN_AS_AND_IF_ISSUED_BOND',
  BANKERS_ACCEPTANCE = 'BANKERS_ACCEPTANCE',
  CERTIFICATES_OF_DEPOSIT = 'CERTIFICATES_OF_DEPOSIT',
  CERTIFICATE_OF_DEPOSIT = 'CERTIFICATE_OF_DEPOSIT',
  COMMERCIAL_PAPER = 'COMMERCIAL_PAPER',
  COMMERCIAL_PAPER_REGULAR_FLAT_DISCOUNT = 'COMMERCIAL_PAPER_REGULAR_FLAT_DISCOUNT',
  COMMERCIAL_PAPER_REGULAR_INTEREST_BEARIN = 'COMMERCIAL_PAPER_REGULAR_INTEREST_BEARIN',
  FIXED_INCOME_UNITS = 'FIXED_INCOME_UNITS',
  ETF = 'ETF',
  VANGUARD_ETF = 'VANGUARD_ETF',
  MISCELLANEOUS_FIXED_INCOME = 'MISCELLANEOUS_FIXED_INCOME',
  MISCELLANEOUS_ASSETS = 'MISCELLANEOUS_ASSETS',
  MISCELLANEOUS_STOCK = 'MISCELLANEOUS_STOCK',
  STOCK = 'STOCK',
  BOND = 'BOND',
  SHORT_TERM_RESERVES = 'SHORT_TERM_RESERVES',
  VARIABLE_ANNUITY = 'VARIABLE_ANNUITY',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}

export enum PositionType {
  UNKNOWN = 'UNKNOWN',
  CASH_ON_DELIVERY = 'CASH_ON_DELIVERY',
  CASH = 'CASH',
  MARGIN = 'MARGIN',
  SHORT = 'SHORT',
  WHEN_ISSUED_CASH_ACCOUNT = 'WHEN_ISSUED_CASH_ACCOUNT',
  FIRM_SPECIFIED = 'FIRM_SPECIFIED',
  SHORT_MARGIN_ACCOUNT = 'SHORT_MARGIN_ACCOUNT',
  FIRM_DEFINED_1 = 'FIRM_DEFINED_1',
  PRECIOUS_METALS = 'PRECIOUS_METALS',
  FIRM_DEFINED_2 = 'FIRM_DEFINED_2',
}

export interface Position {
  positionId: string; //same as holdingIdentifier
  price: string | number;
  balance: string | number;
  ticker: string;
  securityName: string;
  shareQuantity: string | number;
  settlementFund?: boolean;
  vastAccountNumber?: string;
  securityType: SecurityType;
  restricted: boolean;
  positionType?: PositionType;
  cusip?: string;
}

// prettier-ignore
export const restrictedCusipArray = Object.keys({
  '368287207': 'Gazprom Pjsc Chg Spon Adr',
  '607409109': 'Mobile Telesystems Public Joint Stock Co Spon Adr',
  '69269L104': 'Ozon Holdings Plc Spon Ads',
  'N97284108': 'Yandex N V Cl A',
  '583840608': 'Mechel Pao Spons Adr New',
  '69343P105': 'Pjsc Lukoil Spon Adr',
  '55315J102': 'Mmc Norilsk Nickel Chg Pjsc Spon Adr',
  '74735M108': 'Qiwi Plc Spon Adr Repstg Cl B',
  '42207L106': 'Headhunter Group Plc Spons Ads',
  '583840509': 'Mechel Pao Sponsored Adr Repstg Pfd Shs',
  '80585Y308': 'Sberbank Russia Chg Spon Adr',
  'G7114V102': 'Pingtan Marine Enterprise Ltd',
  '73181P102': 'Pjsc Polyus Chg Spon Adr',
  '36829G107': 'Gazprom Neft Pjsc Spon Adr',
  'G57919105': 'Mangazeya Mining Ltd Usd',
  '868861105': 'Surgutneftegaz Pjsc Chg Spons Adr Rep Pfd Shs',
  '876629205': 'Tatneft Pjsc Spon Adr',
  '868861204': 'Surgutneftegaz Pjsc Chg Sponsored Adr',
  '782183404': 'Rushydro Pjsc Chg Spon Adr',
  'G33090104': 'Evraz Plc London',
  '778529107': 'Rostelecom Long Distance & Intl Telecommunication Pub Jt Stk Co Spon Adr',
  'Y14965100': 'China Mobile Ltd',
  'G81701107': 'Silver Bear Resource Plc',
  '30050Y101': 'Evraz Highveld Steel Chg Vanadium Ltd Sponsored Adr',
  '313354102': 'Federal Grid Co Uni Chg Energy System Joint Stock Co Spon Gdr 144a',
  '83418T108': 'Cian Plc Adr',
  '418101101': 'Hashingspace Corp',
  '925326100': 'Vertientes-Camaguey Sugar Co Of Cuba',
  '67812M207': 'Ojsc Oc Rosneft Spon Gdr Reg S',
  'G70539104': 'Petroneft Resources Plc Dublin',
  'G8020E119': 'Semiconductor Mfg Intl Corp New',
  'P3055Q103': 'Compania Anonima Nacional Telefonos De Venezuela Shares D',
  'G7053A101': 'Petropavlovsk Plc',
});

export const restrictedCusipSet = new Set(restrictedCusipArray);
